// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yjbK","colMin":"styles_colMin__3O-ZA"};